import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ 
  show, 
  handleClose, 
  title, 
  bodyText,
  buttonType,
  buttonText,
  onConfirm, 
  confirmArgs = [] // Defaults to an empty array if no args are passed
}) => {

  const handleConfirmClick = () => {
    // Spreads the arguments array into the function
    if (onConfirm) {
      onConfirm(...confirmArgs); 
    }
    handleClose(); // Closes the modal after execution
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <p>{bodyText}</p>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant={buttonType || "primary"} onClick={handleConfirmClick}>
          {buttonText || "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;